import script from "./addjiaoxuerizhi.vue?vue&type=script&setup=true&lang=js"
export * from "./addjiaoxuerizhi.vue?vue&type=script&setup=true&lang=js"

import "./addjiaoxuerizhi.vue?vue&type=style&index=0&id=6afa52cc&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afa52cc"]])

export default __exports__